import { Routes, Route } from "react-router-dom";
// import WebApp from "./pages/WebAppPage/webAppPage";
import LiveLocationViewer from "./pages/ViewerPage/viewerPage";
import NotFound from "./pages/NotFoundPage/notFoundPage";
import { useEffect } from "react";
import { useAppState } from "./core/appState/UseAppStateZustand";
import { getToken } from "./core/api/getToken";
import { writeToLog } from "./const";
// import { maintenanceCheck } from "./core/api/maintenanceCheck";
import MaintenancePage from "./pages/MaintenancePage/maintenancePage";
import FFApp from "./pages/FFAppPage/ffAppPage";


function App() {
  useEffect(() => {
    const { setAccessToken, setAccessTokenExp } = useAppState.getState();

    const refreshToken = async () => {
      const data = await getToken();

      if (data) {
        setAccessToken(data.token);
        setAccessTokenExp(data.exp);

        const now = new Date();

        // Calculate time until expiration
        const timeUntilExpiration =
          new Date(data.exp).getTime() - now.getTime();

        // If the token has already expired, refresh immediately
        if (timeUntilExpiration <= 0) {
          data.token = await refreshToken();
          writeToLog("Token refreshed immediately!");
        } else {
          writeToLog(
            `Token expires in ${
              timeUntilExpiration / 1000
            } seconds. Waiting for expiration...`
          );

          setTimeout(async () => {
            await refreshToken();
          }, timeUntilExpiration);
        }
      }
    };

    refreshToken();
  }, []);

  // const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  // useEffect(() => {
  //   async function checkMaintenanceStatus() {
  //     const data = await maintenanceCheck();

  //     if (data?.maintenance) setIsMaintenanceMode(true);
  //   }

  //   checkMaintenanceStatus();
  // }, []);

  // if (isMaintenanceMode) {
  //   // If maintenance mode is enabled, show the maintenance page for all routes
  //   return <MaintenancePage />;
  // }

  return (
    <Routes>
      <Route path="/"  element={<RedirectUrl url="https://getshane.io/" />} />
      <Route path="/t/:token" element={<LiveLocationViewer />} />
      <Route path="/maintenance" element={<MaintenancePage />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/ff" element={<FFApp />} />
    </Routes>
  );
}

const RedirectUrl = ({ url } : {url : string}) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return <h5>Redirecting...</h5>;
};

export default App;
